import React, { forwardRef } from 'react';
import { InputGroup } from '@icecreamsocial/components';

export const ChonkyInput = forwardRef((props, ref) => {
	return <InputGroup.Input ref={ref} padding='md' {...props} />;
});
